export const Input = 0;
export const Checkbox = 1;
export const List = 2;